import styled from 'styled-components';
import {panelistaPrimaryColor} from 'src/utils/constants';

export const DocumentStyles = styled.div`
  margin-bottom: 40px;
  word-break: break-word;

  h3,
  h2,
  h1 {
    margin-top: 32px;
  }

  & p {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  ul {
    padding-left: 24px;
    list-style-type: circle;
  }

  ol {
    padding-left: 24px;
    list-style-type: decimal;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: ${panelistaPrimaryColor};
  }
`;
